import type Lenis from 'lenis';
import { prefersReducedMotion } from './useReducedMotion';

/** Space kept above a section when jumping to it (floating nav + breathing room). */
export const NAV_OFFSET = 96;

/** Smoothly scroll to a section id (with or without Lenis) and update the hash. */
export function scrollToId(lenis: Lenis | null, id: string, immediate = false): void {
	const el = document.getElementById(id);
	if (!el) return;
	const offset = id === 'accueil' ? 0 : -NAV_OFFSET;

	if (lenis) {
		lenis.scrollTo(el, { offset, immediate, duration: 1.4 });
	} else {
		const top = el.getBoundingClientRect().top + window.scrollY + offset;
		window.scrollTo({ top, behavior: immediate || prefersReducedMotion() ? 'auto' : 'smooth' });
	}

	if (window.location.hash !== `#${id}`) {
		window.history.replaceState(null, '', id === 'accueil' ? window.location.pathname : `#${id}`);
	}
}
